<template>
	<svg
		@click="trigger"
		class="searchPage__searchIcon"
		width="26"
		height="26"
		viewBox="0 0 26 26"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<circle
			cx="15.3605"
			cy="10.5998"
			r="8.98355"
			stroke="#212121"
			stroke-width="2"
		/>
		<line
			x1="10.5425"
			y1="17.421"
			x2="1.5236"
			y2="25.2549"
			stroke="#212121"
			stroke-width="2"
		/>
	</svg>
</template>

<script>
export default {
	name: 'SearchIconSmall',

	methods: {
		trigger() {
			this.$emit('search');
		},
	},
};
</script>
